import { gql } from '@apollo/client'

export const QUERY_USERS = gql`
  query fetchUsers(
    $page: Int
    $limit: Int
    $search: String
    $keyword: String
    $orderBy: String
    $orderDirection: String
    $is_admin: Boolean
  ) {
    users(
      page: $page
      limit: $limit
      search: $search
      keyword: $keyword
      orderBy: $orderBy
      orderDirection: $orderDirection
      is_admin: $is_admin
    ) {
      data {
        id
        fullname
        id_number
        phone
        mobile
        remain
        recommender_fullname
        recommender_id
        guarantor_fullname
        guarantor_id
        cheque_num
        father
        birthday
        postal_code
        place_of_issuance
        job
      }
      total
      per_page
      current_page
    }
  }
`;

export const QUERY_PROFILE = gql`
  query fetchUsers {
    profile {
      id
      name
      lastname
      fullname
      id_number
      id_card_number
      credit
      username
      email
      phone
      mobile
      address
      description
      created_at
      updated_at
      recommender_fullname
      guarantor_fullname
      guarantor_id
      recommender_id
      updated_at
      created_at
    }
  }
`;

export const QUERY_USER = gql`
  query fetchUsers($id: Int) {
    user(id: $id) {
      id
      name
      lastname
      fullname
      id_number
      id_card_number
      credit
      username
      email
      phone
      mobile
      address
      description
      created_at
      updated_at
      recommender_fullname
      guarantor_fullname
      guarantor_id
      recommender_id
      updated_at
      created_at
      cheque_amar
      father
      birthday
      postal_code
      place_of_issuance
      job
    }
  }
`;

export const QUERY_CHEQUES = gql`
  query fetchCheque(
    $page: Int
    $limit: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $percent: Float
    $maxAmount: Float
    $type: String
    $user: Int
    $cheque_id: String
    $icis: String
    $car_contract_id: Int
    $giver_user_id: Int
    $first_party_id: Int
    $second_party_id: Int
    $id: Int
    $recieverable_type: String
    $recieverable_id: Int
    $due_date: String
    $due_date_start: String
    $due_date_end: String
    $amount: String
    $status: String
    $origin_date: String
    $tags: [String]
  ) {
    cheques(
      page: $page
      limit: $limit
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      percent: $percent
      maxAmount: $maxAmount
      type: $type
      user: $user
      cheque_id: $cheque_id
      icis: $icis
      car_contract_id: $car_contract_id
      giver_user_id: $giver_user_id
      first_party_id: $first_party_id
      second_party_id: $second_party_id
      id: $id
      recieverable_type: $recieverable_type
      recieverable_id: $recieverable_id
      due_date: $due_date
      due_date_start: $due_date_start
      due_date_end: $due_date_end
      amount: $amount
      status: $status
      origin_date: $origin_date
      tags: $tags
    ) {
      data {
        id
        amount
        cheque_id

        due_date
        due_date_fa
        cashed_date
        cashed_date_fa
        bounced_date
        bounced_date_fa
        returned_date
        returned_date_fa

        giver_user_fullname
        reciver_user_fullname
        second_party_fullname
        first_party_fullname
        guarantor_id

        giver_user_id
        reciver_user_id
        second_party_id
        first_party_id

        value
        day_left

        chequeable_id
        chequeable_type
        cheque_status

        recieverable_id
        recieverable_type
        recieverable_name

        transfered_date
        icis
        status
      }
      total
      per_page
      current_page
    }
  }
`;

export const QUERY_CAR_CONTRACTS = gql`
  query fetchCarContracts(
    $page: Int
    $limit: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $user: Int
  ) {
    carContracts(
      page: $page
      limit: $limit
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      user: $user
    ) {
      data {
        id

        car_type
        price
        document_type
        document_date
        delivery_date

        document_date_fa

        seller_fullname
        buyer_fullname

        seller_id
        buyer_id
        office
      }
      total
      per_page
      current_page
    }
  }
`;

export const QUERY_CHEQUE_CONTRACTS = gql`
  query fetchChequeContracts(
    $page: Int
    $limit: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $user: Int
  ) {
    chequeContracts(
      page: $page
      limit: $limit
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      user: $user
    ) {
      data {
        id
        ratio
        description
        is_signed
        is_closes
        agreement_date
        agreement_date_fa
        created_at
        updated_at
        first_party_fullname
        second_party_fullname
        first_party_id
        second_party_id
        value_real
        value_agreement
        cheque_num
      }
      total
      per_page
      current_page
    }
  }
`;

export const QUERY_CHEQUE_CONTRACT = gql`
  query fetchChequeContract($id: Int) {
    chequeContract(id: $id) {
      id
      ratio
      description
      is_signed
      is_closes
      agreement_date
      agreement_date_fa
      origin_date
      origin_date_fa
      created_at
      updated_at
      first_party_fullname
      second_party_fullname
      first_party_id
      second_party_id
      value_real
      value_agreement
      cheques_first {
        id
        amount
        cheque_id

        due_date
        due_date_fa
        cashed_date
        cashed_date_fa
        bounced_date
        bounced_date_fa
        returned_date
        returned_date_fa

        giver_user_fullname
        reciver_user_fullname
        second_party_fullname

        giver_user_id
        reciver_user_id
        second_party_id

        value
        day_left

        chequeable_id
        chequeable_type
      }
      cheques_second {
        id
        amount
        cheque_id

        due_date
        due_date_fa
        cashed_date
        cashed_date_fa
        bounced_date
        bounced_date_fa
        returned_date
        returned_date_fa

        giver_user_fullname
        reciver_user_fullname
        second_party_fullname

        giver_user_id
        reciver_user_id
        second_party_id

        value
        day_left

        chequeable_id
        chequeable_type
      }
    }
  }
`;

export const QUERY_CAR_CONTRACT = gql`
  query fetchCarContract($id: Int) {
    carContract(id: $id) {
      id
      seller_id
      buyer_id
      delivery_date
      delivery_date_fa
      delivery_date_print
      notes
      delivered_items
      document_type
      document_date
      document_date_fa
      car_type
      car_color
      current_tag
      next_tag
      motor_number
      vin_number
      barcode
      inspection_center
      inspection_date
      insurance_company
      insurance_id
      insurance_unique_id
      insurance_expire_date
      insurance_expire_date_fa
      price
      profit
      prepayment
      remained
      cheques
      price_buy
      payment_terms
      is_closed
      created_at
      updated_at
      chassis_number
      manufacture_date
      document_number

      seller_fullname
      buyer_fullname

      office
      buyer_other_delivered_items
      seller_other_delivered_items
      Seller {
        father
        lastname
        name
        place_of_issuance
        id_number
        id_card_number
        postal_code
        address
        phone
        mobile
      }
      Buyer {
        father
        lastname
        name
        place_of_issuance
        id_number
        id_card_number
        postal_code
        address
        phone
        mobile
      }
    }
  }
`;

export const QUERY_CHEQUE = gql`
  query fetchCheque($id: Int) {
    cheque(id: $id) {
      id
      amount
      cheque_id
      bank
      bank_branch
      account
      description
      is_guarantee_cheque
      due_date
      due_date_fa
      delivered_date
      delivered_date_fa
      bounced_date
      bounced_date_fa
      cashed_date
      cashed_date_fa
      returned_date
      returned_date_fa
      created_at
      updated_at
      giver_user_fullname
      reciver_user_fullname
      first_party_fullname
      second_party_fullname
      recommender_fullname
      guarantor_fullname
      giver_user_id
      reciver_user_id
      first_party_id
      second_party_id
      guarantor_id
      recommender_id
      day_left

      chequeable_id
      chequeable_type
      chequeable_name

      recieverable_id
      recieverable_type
      recieverable_name

      transfered_date
      icis
      status
    }
  }
`;

export const QUERY_ATTACHMENTS = gql`
  query fetchAttachment(
    $page: Int
    $limit: Int
    $table: String
    $table_id: Int
  ) {
    attachments(
      page: $page
      limit: $limit
      table: $table
      table_id: $table_id
    ) {
      data {
        id
        name
        url
        updated_at
      }
    }
  }
`;

export const QUERY_SETTINGS = gql`
  query fetchSetting {
    settings {
      id
      name
      name_persian
      value
    }
  }
`;

export const QUERY_SETTING = gql`
  query fetchSetting($id: Int) {
    setting(id: $id) {
      id
      name
      name_persian
      value
    }
  }
`;

export const QUERY_DEBIT_CREDITS = gql`
  query debtCredits(
    $page: Int
    $limit: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $user: Int
  ) {
    debtCredits(
      page: $page
      limit: $limit
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      user: $user
    ) {
      data {
        id
        amount
        remained
        created_at
        updated_at
        cleared_at
        cleared_at_fa
        date
        date_fa

        user_id
        user_fullname
        status
        type
        about
        description
      }
      total
      per_page
      current_page
    }
  }
`;

export const QUERY_DEBIT_CREDIT = gql`
  query debtCredit($id: Int) {
    debtCredit(id: $id) {
      id
      amount
      remained
      created_at
      updated_at
      cleared_at
      cleared_at_fa
      date
      date_fa
      User {
        id
      }
      user_id
      user_fullname
      status
      type
      about
      description
    }
  }
`;

export const QUERY_DEBIT_CREDITS_TOTAL = gql`
  query DebtCreditsTotalQuery($user: Int) {
    DebtCreditsTotalQuery(user: $user) {
      debit
      credit
      bounced
      cached
      current
    }
  }
`;

export const QUERY_BANK_ACCOUNTS = gql`
  query bankAccounts(
    $page: Int
    $limit: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $user: Int
  ) {
    bankAccounts(
      page: $page
      limit: $limit
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      user: $user
    ) {
      data {
        id
        user_id
        user_fullname
        bank
        branch
        branch_code
        account
        ibn
        card
        description
      }
      total
      per_page
      current_page
    }
  }
`;

export const QUERY_BANK_ACCOUNT = gql`
  query bankAccount($id: Int) {
    bankAccount(id: $id) {
      id
      user_id
      user_fullname
      bank
      branch
      branch_code
      account
      ibn
      card
      description
      created_at
      updated_at
    }
  }
`;

export const QUERY_LEGAL_ENTITIES = gql`
  query legalEntities(
    $page: Int
    $limit: Int
    $search: String
    $orderBy: String
    $orderDirection: String
  ) {
    legalEntities(
      page: $page
      limit: $limit
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      data {
        id
        name
        email
        website
        phone
        mobile
        address
        description
        national_code
        register_no
        created_at
        updated_at
      }
      total
      per_page
      current_page
    }
  }
`;

export const QUERY_LEGAL_ENTITY = gql`
  query legalEntity($id: Int) {
    legalEntity(id: $id) {
      id
      name
      email
      website
      phone
      mobile
      address
      description
      register_no
      national_code
      created_at
      updated_at
    }
  }
`;

export const QUERY_CHEQUE_AUDITS = gql`
  query ChequeAuditsQuery(
    $page: Int
    $limit: Int
    $search: String
    $orderBy: String
    $orderDirection: String
    $id: Int
  ) {
    ChequeAuditsQuery(
      page: $page
      limit: $limit
      search: $search
      orderBy: $orderBy
      orderDirection: $orderDirection
      id: $id
    ) {
      data {
        id
        user_type
        event
        auditable_type
        auditable_id
        old_values
        new_values
        url
        ip_address
        user_agent
        tags
        user_fullname
        created_at
        updated_at
        User {
          id
          name
          lastname
          fullname
          id_number
          id_card_number
        }
        Cheque {
          id
          amount
          cheque_id

          due_date
          due_date_fa
          cashed_date
          cashed_date_fa
          bounced_date
          bounced_date_fa
          returned_date
          returned_date_fa

          giver_user_fullname
          reciver_user_fullname
          second_party_fullname
          first_party_fullname
          guarantor_id

          giver_user_id
          reciver_user_id
          second_party_id
          first_party_id

          value
          day_left

          chequeable_id
          chequeable_type
          cheque_status

          recieverable_id
          recieverable_type
          recieverable_name

          transfered_date
          icis
          status
        }
      }
      total
      per_page
      current_page
    }
  }
`;

export const QUERY_GLOBAL_SEARCH = gql`
  query GlobalSearch($search: String!, $limit: Int) {
    globalSearch(search: $search, limit: $limit) {
      type
      id
      title
      subtitle
    }
  }
`;

export const QUERY_CHEQUE_STATS_BY_USER = gql`
  query ChequeStats($userId: Int!) {
    chequeStatsByUser(user_id: $userId) {
      owner {
        bounced
        bouncedAmount
        cashed
        cashedAmount
        current
        currentAmount
      }
      giver {
        bounced
        bouncedAmount
        cashed
        cashedAmount
        current
        currentAmount
      }
    }
  }
`;

export const QUERY_CHEQUE_RETURNED_STATS_BY_USER = gql`
  query ChequeReturnedStats($userId: Int!) {
    chequeStatsByUser(user_id: $userId) {
      owner {
        returned
        returnedAmount
      }
      giver {
        returned
        returnedAmount
      }
    }
  }
`;
